<template>
  <div style="width: 100%;height:100%;overflow: auto;" v-loading="isLoading">
    <div class="main-card history">
      <div class="history-wrap">
      <!---------- history head ---------->
        <div class="history-head">
          <div class="title"><i class="mng icon-history-fill"></i><span>修改动态</span></div>
          <div class="append"><a href="javascript:;" class="btn btn-hollow-primary" @click="close">返回</a></div>
        </div>
      <!---------- history head end ---------->

      <!---------- history body ---------->
      <div class="history-body clearfix">
        <!---------- show ---------->
        <div class="history-show" v-if="!isDeleteRecord" style="width: 30%;">
          <div class="history-info">当前数据</div>
          <el-scrollbar ref="leftScrollbar" class="whaty-scroll mTable-body myTableBody" wrap-class="whaty-scroll-wrap"
                        :style="{height: bodyHeight + 'px'}">
            <div class="history-inner">
              <div class="list no-bottom-border">
                <div class="list-row" v-for="(value, key) in currentData">
                  <span class="list-head" :title="key">{{ key }}</span>
                  <div class="list-body">
                    <el-tooltip class="item" :open-delay="700" effect="dark" :content="nonNullValue(value)"
                                placement="top">
                      <span>{{ nonNullValue(value) }}</span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <!---------- show end ---------->

        <!---------- record ---------->
        <div class="history-record" :style="{width: isDeleteRecord ? '100%' : '69.9%'}">

          <div class="history-info">
            说明：
            <span class="lab lab-red lab-anti"><span class="lab-text">红色</span></span>表示修改前，
            <span class="lab lab-green lab-anti"><span class="lab-text">绿色</span></span>表示修改后
            <span class="lab lab-gray lab-anti"><span class="lab-text">&lt;空&gt;</span></span>表示无数据
          </div>
          <el-scrollbar ref="rightScrollbar" class="whaty-scroll mTable-body myTableBody" wrap-class="whaty-scroll-wrap"
                        :style="{height: bodyHeight + 'px'}">
            <div class="history-inner" style="background-color: white;">
              <div class="record-row" v-for="data in statusData">
                <div class="record-row-wrap">
                  <div class="record-row-head clearfix">
                    <span class="pull-left name"><i class="mng icon-login-user-fill"></i>
                      <span class="text">{{ data.operateUser }}</span>
                      <span class="pull-right time">{{ data.operateTime }}</span>
                    </span>
                    <span class="pull-right time">{{ data.operateName }}</span>
                  </div>
                  <div class="record-row-body">
                    <div class="list">
                      <div class="list-row" v-for="diff in data.diffs">
                        <span class="list-head">{{ diff.label }}:</span>
                        <div class="list-body">
                          <el-tooltip class="item" :open-delay="700" effect="dark" :content="nonNullValue(diff.before)" placement="top">
                            <span class="lab lab-red lab-anti"><span class="lab-text">{{ nonNullValue(diff.before) }}</span></span>
                          </el-tooltip>
                          <span>修改为</span>
                          <el-tooltip class="item" :open-delay="700" effect="dark" :content="nonNullValue(diff.after)" placement="top">
                            <span class="lab lab-green lab-anti"><span class="lab-text">{{ nonNullValue(diff.after) }}</span></span>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <!---------- record end ---------->
      </div>
      <!---------- history body end ---------->
    </div>
    </div>
  </div>
</template>

<script>
  import util from '@/libs/util'
  import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'

  export default {
    props: {
      id: {
        type: String
      },
      currentData: {
        type: Object
      },
      namespace: {
        type: String
      }
    },
    name: 'data-history-draw',
    data() {
      return {
        isLoading: false,
        statusData: null,
        emptyData: [],
        pageHeight: 200,
        isDeleteRecord: this.$route.name === 'showDeleteRecord'
      }
    },
    mounted() {
      this.isLoading = true
      util.ajax.get('/entity/record/dataHistorySearch/changeDataHistory?namespace=' + this.namespace + '&id=' + this.id).then(res => {
        if (res.data.meta && res.data.meta.errCode === 0) {
          this.statusData = res.data.data
        } else {
          this.$notify.warning({title: '警告', message: res.data.meta.errMsg})
        }
        this.isLoading = false
      }).catch(err => {
        console.error(err)
        this.$notify.error({title: '提示', message: '系统错误'})
        this.isLoading = false
      })
      this.$nextTick(this.update)
      addResizeListener(this.$el, this.update)
      // 创建浏览器返回按钮监听
      if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL)
        addEventListener('popstate', this.goPageBefore, false)
      }
    },
    beforeDestroy() {
      removeResizeListener(this.$el, this.update)
      removeEventListener('popstate', this.goPageBefore, false)
    },
    computed: {
      bodyHeight: function () {
        return this.pageHeight - 140
      }
    },
    methods: {
      update: function () {
        this.$nextTick(() => {
          this.pageHeight = this.$el.offsetHeight
          this.updateElScroller()
        })
      },
      goPageBefore() {
        this.close()
      },
      close: function () {
        this.$emit('close')
      },
      nonNullValue: function (value) {
        return value && value !== null && value !== '' ? (value + '') : '<空>'
      },
      updateElScroller() {
        if (this.$refs.leftScrollbar) {
          this.$refs.leftScrollbar.update()
        }
        if (this.$refs.rightScrollbar) {
          this.$refs.rightScrollbar.update()
        }
      }
    }
  }
</script>

<style scoped>
  .el-scrollbar {
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/record/data-history-draw.vue